<template>
  <footer class="footer-section">
    <!--footer top start-->
    <div class="footer-top gradient-bg">
      <div class="container">
        <div class="row">
          <div class="col-md-9">
            <div class="row footer-top-wrap">
              <!-- Быстрые ссылки -->
              <div class="col-md-3 col-sm-6">
                <div class="footer-nav-wrap text-white">
                  <h4 class="text-white">{{ $t('footer.quick_links.title') }}</h4>
                  <ul class="nav flex-column">
                    <li class="nav-item">
                      <router-link to="/public/developers" class="nav-link">
                        {{ $t('footer.quick_links.developers') }}
                      </router-link>
                    </li>
                    <li class="nav-item">
                      <router-link to="/public/agencies" class="nav-link">
                        {{ $t('footer.quick_links.agencies') }}
                      </router-link>
                    </li>
                    <li class="nav-item">
                      <router-link to="/public/properties" class="nav-link">
                        {{ $t('footer.quick_links.properties') }}
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>

              <!-- Компания -->
              <div class="col-md-3 col-sm-6">
                <div class="footer-nav-wrap text-white">
                  <h4 class="text-white">{{ $t('footer.company.title') }}</h4>
                  <ul class="nav flex-column">
                    <li class="nav-item">
                      <router-link to="/about" class="nav-link">
                        {{ $t('footer.company.about_services') }}
                      </router-link>
                    </li>
                    <!-- Можешь позже раскомментировать -->
                    <!-- <li class="nav-item"><span class="nav-link">{{ $t('footer.company.affiliate_program') }}</span></li> -->
                    <!-- <li class="nav-item"><span class="nav-link">{{ $t('footer.company.blog') }}</span></li> -->
                    <!-- <li class="nav-item"><span class="nav-link">{{ $t('footer.company.careers') }}</span></li> -->
                  </ul>
                </div>
              </div>

              <!-- Новости -->
              <div class="col-md-3 col-sm-6">
                <div class="footer-nav-wrap text-white">
                  <h4 class="text-white">{{ $t('footer.company.news') }}</h4>
                  <ul class="nav flex-column">
                    <li class="nav-item">
                      <router-link to="/public/news" class="nav-link">{{ $t('footer.company.news') }}</router-link>
                    </li>
                    <li class="nav-item">
                      <router-link to="/public/properties/statistic" class="nav-link">{{ $t('footer.company.statistic') }}</router-link>
                    </li>
                  </ul>
                </div>
              </div>

              <!-- Поддержка (пока закомментирована) -->
              <div class="col-md-3 col-sm-6">
                <div class="footer-nav-wrap text-white">
                  <h4 class="text-white">{{ $t('footer.support.title') }}</h4>
                  <ul class="nav flex-column">
                    <!-- <li class="nav-item"><span class="nav-link">{{ $t('footer.support.contact') }}</span></li> -->
                    <!-- <li class="nav-item"><span class="nav-link">{{ $t('footer.support.knowledge_base') }}</span></li> -->
                    <!-- <li class="nav-item"><span class="nav-link">{{ $t('footer.support.forums') }}</span></li> -->
                    <!-- <li class="nav-item"><span class="nav-link">{{ $t('footer.support.system_status') }}</span></li> -->
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- Контакты -->
          <div class="col-md-3">
            <div class="row footer-top-wrap">
              <div class="col-12">
                <div class="footer-nav-wrap text-white">
                  <h4 class="text-white">{{ $t('footer.get_in_touch') }}</h4>
                  <ul class="get-in-touch-list">
                    <li class="d-flex align-items-center py-2">
                      <i class="fa-solid fa-envelope mr-2" />
                      <span>{{ $t('footer.email') }}</span>
                    </li>
                    <li class="d-flex align-items-center py-2">
                      <i class="fa-solid fa-phone-alt mr-2" />
                      <a
                        :href="`https://wa.me/${$t('footer.phone')}`"
                        target="_blank"
                        rel="noopener"
                        class="text-white"
                      >
                        {{ $t('footer.phone') }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--footer copyright start-->
    <div class="footer-bottom gray-light-bg py-2">
      <div class="container">
        <div class="row align-items-center justify-content-between">
          <div class="col-md-5 col-lg-5">
            <p class="copyright-text pb-0 mb-0">{{ $t('footer.copyright') }}</p>
          </div>
          <div class="col-md-7 col-lg-6 d-none d-md-block d-lg-block">
            <div class="social-nav text-right">
              <ul class="list-unstyled social-list mb-0">
                <!-- Добавь соцсети, если нужно -->
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--footer copyright end-->
  </footer>
</template>

<script setup>
// импортировать ничего не нужно, всё через i18n
</script>
